import {
  queryOptions,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { backendApi } from "../../api";

export function userEmailVerificationSent(email: string) {
  return queryOptions({
    queryKey: ["resend-verification-email", email],
    queryFn: () => false,
    // staleTime: 1000 * 60 * 1, // Expire after 1 minute
  });
}

export function useResendEmailVerification(email: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () =>
      await backendApi({
        url: "/users/resend-verification-email",
        data: { email: email },
        method: "POST",
      }),
    onSuccess: () =>
      queryClient.setQueryData(userEmailVerificationSent(email).queryKey, true),
    onError: () =>
      queryClient.setQueryData(
        userEmailVerificationSent(email).queryKey,
        "failed"
      ),
  });
}
